var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFigma = function SvgFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M8.55 8.377c0-1.289 1.019-2.333 2.275-2.333S13.1 7.087 13.1 8.377s-1.018 2.333-2.275 2.333c-1.255 0-2.275-1.043-2.275-2.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M4 13.044c0-1.289 1.019-2.334 2.275-2.334H8.55v2.334c0 1.288-1.019 2.333-2.275 2.333S4 14.332 4 13.044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M8.55 1.377v4.667h2.275C12.082 6.044 13.1 5 13.1 3.71c0-1.288-1.018-2.333-2.275-2.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M4 3.71C4 5 5.019 6.044 6.275 6.044H8.55V1.377H6.275C5.019 1.377 4 2.422 4 3.71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M4 8.377c0 1.29 1.019 2.333 2.275 2.333H8.55V6.044H6.275C5.019 6.044 4 7.087 4 8.377"
  })));
};
export default SvgFigma;